
import React, { useEffect } from 'react';
import '../Assets/Css/consultant.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { FaStar, FaHandshake, FaUsers, FaBriefcase } from 'react-icons/fa';
import { IoArrowForwardCircleOutline } from "react-icons/io5";

// testimonials
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export default function Diversity() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const testimonials = [
        "I appreciate the steady support and professional guidance from Trident throughout my assignments.",
        "I recently began a contract through Trident. Working with Sridhar and Neetu has been outstanding—they’ve assisted me every step of the way.",
        "When I faced a job loss, Trident secured me a position at Intel at my requested pay rate within days. Their commitment is impressive.",
        "My experience with Trident stands out among consulting firms. The team, especially Mohan and Sridhar, is respectful, focused on goals, and truly people-oriented.",
        "Trident’s commitment to innovation and quality has made them a trusted partner in our digital transformation journey."
    ];

   

    return (
        <>
          <Helmet>
        <title>Trident Consultants - Trusted Talent & Testimonials</title>
        <meta
          name="description"
          content="Discover what our consultants say about partnering with Trident. Trusted staffing with integrity, diversity, and personalized support."
        />
      </Helmet>


            {/* Banner Section */}
            <div className="bannerconsultant-section d-flex align-items-center justify-content-center">
        <div className="bannerconsultant-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Consulting Excellence Meets Cutting-Edge Solutions</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
           Empowering organizations with diverse talent and industry-leading enterprise software expertise.
          </p>
        </div>
      </div>

          <Container className="py-5">
  <Row className="justify-content-center">
    <Col md={10}>
      <div className="who-we-are-section p-5 rounded shadow-sm" data-aos="fade-up">
        <h3 className="fw-bold section-title mb-4">About Trident Consultants</h3>
        <p className=" text-dark fs-6" style={{textAlign:'justify'}}>
          At Trident, our consultants are at the forefront of empowering businesses with cutting-edge technology solutions. 
          From ERP and CRM to Supply Chain, HRMS, Production Planning, and Retail POS systems, our experts deliver tailored solutions that drive success.
          Unlike traditional staffing agencies, we build lasting partnerships, respect your professional value, and support your career journey every step of the way.
          Transparency, diversity, and inclusion are core to our ethos — creating an environment where consultants thrive and clients benefit.
        </p>
        <Row className="mt-4 text-center">
          <Col md={4} className="mb-3">
            <FaHandshake size={40} className="text-primary mb-2" />
            <h5>Long-Term Partnerships</h5>
            <p>We nurture ongoing consultant relationships that foster growth and repeated client successes.</p>
          </Col>
          <Col md={4} className="mb-3">
            <FaUsers size={40} className="text-success mb-2" />
            <h5>Diversity & Inclusion</h5>
            <p>Championing an inclusive culture where diverse talent drives innovation and excellence.</p>
          </Col>
          <Col md={4} className="mb-3">
            <FaBriefcase size={40} className="text-warning mb-2" />
            <h5>Expertise Across Domains</h5>
            <p>Delivering skilled consultants specializing in ERP, CRM, Supply Chain, HRMS, and more.</p>
          </Col>
        </Row>
      </div>
    </Col>
  </Row>
</Container>



 <section className="ctasection text-white d-flex align-items-center" >
                <div className="container">
                    <div className="row align-items-center" data-aos="zoom-in" data-aos-delay="200">
                        <div className="col-12">
                            <div className="ctasection-content p-4 p-md-5 text-center">
                                <h2
                                    className="fw-bold mb-4"
                                    style={{
                                        fontFamily: "'Playfair Display', serif",
                                        fontSize: '2.5rem',
                                        letterSpacing: '1px',
                                    }}
                                >
                                  Ready to Transform Your Business?
                                </h2>
                                <p
                                    className="mb-4"
                                    style={{
                                        fontSize: '1.15rem',
                                        lineHeight: '1.6',
                                        color: '#f8f1e7',
                                        maxWidth: '750px',
                                        margin: '0 auto',
                                    }}
                                >
                                 Contact Trident Software Services today and let’s start your digital transformation journey together.
                                </p>
                                <Button variant="light" className="banner1-button mt-3 " href='/contact'
                                    data-aos="zoom-in" data-aos-delay="300">
                                  Get In Touch <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
  

            <section className="testimonial-carousel-section my-5">
                <div className="container py-3 ">
                    <Row className="align-items-center justify-content-center flex-md-row m-0">
                        <h3 className="fw-bold text-center section-title">
                            Empowering Innovation Through Experience
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                            Hear what our clients say about transforming their business with Trident Software Services.
                        </p>
                        <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                            <Swiper
                                modules={[Autoplay, Pagination, Navigation]}
                                spaceBetween={30}
                                loop={true}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{ clickable: true }}
                                navigation={true}
                                className="testimonial-swiper"
                            >
                                {testimonials.map((text, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className="stars mb-1">
                                            {[...Array(5)].map((_, i) => (
                                                <FaStar key={i} color="#d23f57" />
                                            ))}
                                        </div>
                                        <p className="testimonial-quote">
                                            <span className="quote-mark">“</span>
                                            {text}
                                            <span className="quote-mark">”</span>
                                        </p>
                                        <p className="author-name">Anonymous</p>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Col>
                    </Row>
                </div>
            </section>


        </>
    );
}
